
import React from 'react';
import { SupabaseSignIn } from '@/components/auth/SupabaseAuthComponents';
import { RedirectIfAuthenticated } from '@/components/auth/RedirectIfAuthenticated';

const Login: React.FC = () => {
  return (
    <RedirectIfAuthenticated>
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
        <SupabaseSignIn />
      </div>
    </RedirectIfAuthenticated>
  );
};

export default Login;
